import { ApolloClient, InMemoryCache, ApolloProvider, HttpLink } from '@apollo/client'
import { ComponentType, ReactElement } from 'react'
import fetch from 'cross-fetch'

const SERVER_URL =
    process.env.NODE_ENV === 'test'
        ? 'http://localhost/api/graphql'
        : process.env.REACT_APP_MP_GRAPHQL_SERVER_URL ?? '/api/certification/graphql'

export const client = new ApolloClient({
    link: new HttpLink({ uri: SERVER_URL, fetch }),
    cache: new InMemoryCache({
        dataIdFromObject(obj) {
            return `${obj.__typename}:${obj._id ?? obj.id}`
        },
        typePolicies: {
            Certificate: {
                fields: {
                    createdAt: {
                        read(date: string) {
                            return new Date(date)
                        },
                    },
                    quizStartedAt: {
                        read(date: string) {
                            return new Date(date)
                        },
                    },
                    quizFinishedAt: {
                        read(date: string) {
                            return new Date(date)
                        },
                    },
                },
            },
            PublicCertificate: {
                fields: {
                    createdAt: {
                        read(date: string) {
                            return new Date(date)
                        },
                    },
                    quizStartedAt: {
                        read(date: string) {
                            return new Date(date)
                        },
                    },
                    quizFinishedAt: {
                        read(date: string) {
                            return new Date(date)
                        },
                    },
                },
            },
        },
    }),
})

interface ChildrenProps {
    children: ReactElement
}

export function GraphQlProvider({ children }: ChildrenProps) {
    return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export function withGraphql<T>(Component: ComponentType<T>) {
    return (props: T) => (
        <GraphQlProvider>
            {/* @ts-ignore */}
            <Component {...props} />
        </GraphQlProvider>
    )
}
